import api from '../api/axios';

/**
 * Check if Google Places integration is active
 */
const getStatus = () => {
  return api.get('/places/status');
};

/**
 * Search addresses using Google Places Autocomplete
 * @param {string} input - Search query
 * @param {string} sessionToken - Optional session token for billing optimization
 */
const autocomplete = (input, sessionToken) => {
  const params = new URLSearchParams({ input });
  if (sessionToken) {
    params.append('sessionToken', sessionToken);
  }
  return api.get(`/places/autocomplete?${params}`);
};

/**
 * Get place details by place_id
 * @param {string} placeId - Google place_id
 * @param {string} sessionToken - Optional session token for billing optimization
 */
const getDetails = (placeId, sessionToken) => {
  const params = new URLSearchParams({ placeId });
  if (sessionToken) {
    params.append('sessionToken', sessionToken);
  }
  return api.get(`/places/details?${params}`);
};

/**
 * Generate a random session token for Google Places API billing optimization
 * Session tokens group autocomplete and details requests together
 */
const generateSessionToken = () => {
  return crypto.randomUUID ? crypto.randomUUID() : 
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
    });
};

const placesServices = {
  getStatus,
  autocomplete,
  getDetails,
  generateSessionToken,
};

export default placesServices;

